import { menuArray } from "common/container/constants";

// LeftSidebar component receives props to handle state and actions
export const LeftSidebar = ({
  isSidebarOpen,
  setSideBarOpen,
  color,
  setColor,
  onItemClick,
}: {
  isSidebarOpen: boolean;
  setSideBarOpen: Function;
  color: string;
  setColor: Function;
  onItemClick;
}) => {
  console.log({ color });
  return (
    <div className="flex flex-col py-[50%]  bg-primary-color  p-4 space-y-6 sticky top-0">
      {/* Iterate over the menu items */}
      {menuArray.map((menu, menuIndex) => (
        <div
          key={menuIndex}
          className={`w-full p-3 flex space-x-5   cursor-pointer ${color === menu.speed ? "border-2 rounded-xl" : ""} ${
            isSidebarOpen ? "justify-start" : "justify-start"
          }`}
          onClick={() => onItemClick(menu.speed)}
        >
          <span className="mt-1 ml-3 ">
            {menu.svg && <menu.svg className={` ${color == menu.speed ? "white " : "#4A4A4A"}`} />}
          </span>

          <span className={` 2xl:text-[18px] xl:text-[14px] lg:text-[14px]  ${color === menu.speed && "text-white"}`}>
            {menu.MainMenu}
          </span>
        </div>
      ))}
    </div>
  );
};
